module.exports = __webpack_public_path__ + "static/img/event11.1234426.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event11.png
// module id = F8xj
// module chunks = 1